import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { subscriptionActive } from "../../api/handleapi";

export const useSubscriptionAccess = (moduleKey) => {
  const subscriptionInfo = useSelector((state) => state.subscriptionInfo);
  const planType = subscriptionInfo?.product?.store_identifier;
  const isExpired = (subscriptionInfo?.status !== 'active') ? true : false;

  const accessMatrix = {
    'prod_TFpqc9jJTMo4qt': ["dashboard", "my-league", "profile", "create-league", "no-ads", 'comments-notices'],
    'prod_TFq1SAMQreV6I5': ["dashboard", "my-league", "profile", "create-league", "no-ads", "comments-notices", "release-calendar"],
    'prod_TFq22tgYn9LJXg': ["dashboard", "my-league", "profile", "create-league", "no-ads", "comments-notices", 'release-calendar', "forum", "ask-the-expert"],
    
    'prod_TFTiqMF21yeRdZ': ["dashboard", "my-league", "profile", "create-league", "no-ads", 'comments-notices'],
    'prod_TFTkCNeqRul4lM': ["dashboard", "my-league", "profile", "create-league", "no-ads", "comments-notices", "release-calendar"],
    'prod_TFThxHq964cYX7': ["dashboard", "my-league", "profile", "create-league", "no-ads", "comments-notices", 'release-calendar', "forum", "ask-the-expert"],
  };

  const hasAccess =
    !isExpired && accessMatrix[planType]?.includes(moduleKey) || false;

  return {
    planType,
    hasAccess,
    isExpired,
    subscriptionInfo,
  };
};